import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout";
import { AuthProvider, useAuth, isAdmin } from "@/state/AuthContext";
import { LoadingState } from "@/components/PageHeader";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { RfqNewPage } from "@/pages/RfqNewPage";
import { RfqDetailPage } from "@/pages/RfqDetailPage";
import { AdminCustomersPage } from "@/pages/admin/AdminCustomersPage";
import { AdminSellersPage } from "@/pages/admin/AdminSellersPage";
import { AdminUsersPage } from "@/pages/admin/AdminUsersPage";
import { AdminCustomFieldsPage } from "@/pages/admin/AdminCustomFieldsPage";

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { token, loading } = useAuth();
  if (loading) return <LoadingState />;
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (!isAdmin(user)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="rfqs/new" element={<RfqNewPage />} />
        <Route path="rfqs/:rfqId" element={<RfqDetailPage />} />
        <Route path="admin/customers" element={<AdminRoute><AdminCustomersPage /></AdminRoute>} />
        <Route path="admin/sellers" element={<AdminRoute><AdminSellersPage /></AdminRoute>} />
        <Route path="admin/users" element={<AdminRoute><AdminUsersPage /></AdminRoute>} />
        <Route path="admin/custom-fields" element={<AdminRoute><AdminCustomFieldsPage /></AdminRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
